import {
  invoiceControlStatusConfig,
  LoggedUser,
  projectStatusByCode,
  InvoiceProjectByStatus,
} from 'entities';

import { ListSorters } from 'components/ListManipulation';

export function getSorters(
  status: string,
  user: LoggedUser,
): ListSorters<InvoiceProjectByStatus>[] {
  const { unassigned } = invoiceControlStatusConfig;

  const sorters: (ListSorters<InvoiceProjectByStatus> | null)[] = [
    {
      getLabel: (t) => t('client'),

      id: 'CLIENT',

      sorter: (a, b) => {
        const [aClientName, bClientName] = [a, b].map(({ project: { clientName } }) => clientName);

        return aClientName.localeCompare(bClientName);
      },
    },
    {
      getLabel: (t) => t('status'),

      id: 'PROJECT_STATUS',

      sorter: (a, b) => {
        const [aOrder, bOrder] = [a, b].map(
          ({ project: { status } }) => projectStatusByCode[status].order,
        );

        return aOrder - bOrder;
      },
    },
    {
      getLabel: (t) => t('project-total'),

      id: 'VALUE',

      sorter: (a, b) => {
        const [aMonetary, bMonetary] = [a, b].map(({ project: { currency, total } }) => ({
          currency,
          value: total,
        }));

        if (aMonetary.currency !== bMonetary.currency)
          return aMonetary.currency.localeCompare(bMonetary.currency);

        const [valueA, valueB] = [aMonetary.value, bMonetary.value].map(Number);

        return valueB - valueA;
      },
    },

    status !== unassigned.code
      ? {
          getLabel: (t) => t('owner'),

          id: 'OWNER',

          sorter: (a, b) => {
            const [ownerA, ownerB] = [a, b].map(({ owner }) =>
              owner.id === user.id ? `###-${owner.name}` : owner.name,
            );

            return ownerA.localeCompare(ownerB);
          },
        }
      : null,
  ];

  return sorters.filter(Boolean) as ListSorters<InvoiceProjectByStatus>[];
}
